import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

const TopicName = ({ topicList, topicName, handleTopicChange, topicId }) => {
  return (
    <div>
      <Autocomplete
        disablePortal
        size="small"
        id="combo-box-demo"
        options={topicList}
        getOptionLabel={(option) => option.topicName}
        renderInput={(params) => <TextField {...params} label="Topic Names" />}
        value={topicId === 0 ? null : { topicId, topicName }}
        onChange={(event, newValue) => {
          handleTopicChange(newValue);
        }}
      />
    </div>
  );
};

export default TopicName;
